import * as React from "react";
import { UploadedTmpFile } from "Pages/Project/Documents/FileUpload/FileUploadStore";
import { withTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { PathDirectorySelect, PathDirectorySelectProps } from "Components/Form/PathDirectorySelect";

interface PathDirectorySelectPlaceholderProps extends PathDirectorySelectProps {
  onChangeForFile?: (selectedFolderId: number, file: UploadedTmpFile) => void;
  file: UploadedTmpFile;
  disabled?: boolean;
  children?: React.ReactNode;
}

interface PathDirectorySelectPlaceholderState {
  clicked: boolean;
}

export const PathDirectorySelectPlaceholder = withTranslation(I18N_NS.PROJECT)(
  class extends React.Component<PathDirectorySelectPlaceholderProps, PathDirectorySelectPlaceholderState> {
    constructor(props: PathDirectorySelectPlaceholderProps) {
      super(props);
      this.state = {
        clicked: false,
      };
    }

    handleChange = (changedValue) => {
      const { onChangeForFile, file } = this.props;
      if (onChangeForFile) {
        onChangeForFile(changedValue, file);
      }
    };

    handleClick = () => {
      if (this.props.disabled) {
        return;
      }
      this.setState({ clicked: true });
    };

    render() {
      return this.state.clicked ? (
        <PathDirectorySelect value={this.props.value} onChange={this.handleChange} />
      ) : (
        <div onClick={this.handleClick}>{this.props.children}</div>
      );
    }
  }
);
